export default __webpack_public_path__ + "static/media/Swimming Complex, Ambala1.a9b49fd7.jpg";